import { prop } from 'ramda';
import React, { useCallback, useEffect, Suspense } from 'react';
import { useDispatch } from 'react-redux';
import { Login } from '@core/js/components/main/Login';
import { BACKBONE_APP_ROOT } from '@core/js/backbone/constants';
import { ManagedPopup } from '@theme/js/components/common/Popup';
import { scrollService } from '@core/js/services/scroll.service';
import { WebContentInner } from '@core/js/components/system/WebContent';
import { useCombinedOnClose } from '@core/js/components/common/PopupManager';
import { useAuthSelector, useAppSelector, useUserSelector } from '@core/js/store/hooks';
import { updateDeviceAction } from '@core/js/hooks/device/store/actions';
import { getBaseClasses, getOrientation } from '@core/js/hooks/device/helpers';

import style from './LoginPopup.scss';

/* Lugano changes */
const popupClassNames = {
    inner: style.popupInner
};
/* Lugano changes */

const layerClassNames = {
    layout: style.layout
};

export const LoginPopup = ({ id, title, onClose, onLogin, controls }) => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const loginWebContent = useAppSelector(prop('loginWebContent'));
    const dispatch = useDispatch(); /* Lugano changes */
    const closePopup = useCombinedOnClose(onClose, id);
    const isLoginInProcess = useAuthSelector(prop('isLoginInProcess'));

    /* Lugano changes */
    const updateDeviceOrientation = useCallback(
        () => {
            dispatch(updateDeviceAction(getOrientation()));
            document.querySelector('html').classList = getBaseClasses();
        },
        [dispatch]
    );

    useEffect(() => {
        if (!isLoggedIn) {
            window.addEventListener('orientationchange', updateDeviceOrientation);

            return () => {
                window.removeEventListener('orientationchange', updateDeviceOrientation);
            };
        }
    }, [updateDeviceOrientation, isLoggedIn]);
    /* Lugano changes */

    useEffect(() => {
        if (!isLoggedIn || isLoginInProcess) {
            return;
        }

        if (onLogin) {
            onLogin();
        }

        closePopup();
        scrollService.scrollTo(0);
    }, [closePopup, isLoggedIn, onLogin, isLoginInProcess]);

    return (
        <ManagedPopup
            id={id}
            title={title}
            classNames={popupClassNames} /* Lugano changes */
            controls={controls}
            onClose={closePopup}
            className={style.container}
            layerClassNames={layerClassNames}
        >
            <Suspense fallback="">
                <Login
                    className={`${style.loginPopupContainer} ${BACKBONE_APP_ROOT}`}
                />
            </Suspense>
            {loginWebContent &&
                <WebContentInner
                    popupId={id}
                    content={loginWebContent}
                    className={`${style.loginWc} ${BACKBONE_APP_ROOT}`}
                />
            }
        </ManagedPopup>
    );
};
